import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpis-am',
  templateUrl: './kpis-am.component.html',
  styleUrls: ['./kpis-am.component.scss']
})
export class KpisAmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
